import type { EfteruddannelsesperiodeIndberetningOverviewModel } from "@/interfaces/efteruddannelsesperiodeIndberetningOverview";
import { isUpcomingPeriod } from "@/util/date";

export type ReportingPeriodStatusPresentation = {
  className: string;
  label: string;
};

export const INDBERETTET_LABEL = "Indberettet";

/**
 * Vises for en periode, der er oprettet, men endnu ikke begyndt.
 *
 * AIKA opretter efteruddannelsesperioden, så snart medlemmet bliver udøvende, men den
 * løber først fra den 1. i måneden efter. I den mellemtid er perioden hverken nuværende
 * eller afsluttet, og uden en egen tilstand faldt den ned i "Afventer indberetning" -
 * en gul advarsel om noget, medlemmet hverken kan eller skal gøre endnu.
 */
export const KOMMENDE_PERIODE_LABEL = "Kommende periode";

export const NUVAERENDE_PERIODE_LABEL = "Nuværende periode";

export const AFVENTER_INDBERETNING_LABEL = "Afventer indberetning";

type ReportingPeriodStatusInput = Pick<
  EfteruddannelsesperiodeIndberetningOverviewModel,
  "indsendt" | "frist" | "erNuvaerendePeriode" | "periodeFraDato"
>;

export const getReportingPeriodStatusPresentation = (
  period: ReportingPeriodStatusInput,
  now: Date = new Date(),
): ReportingPeriodStatusPresentation => {
  if (period.indsendt) {
    return {
      className: "cle-status-badge--success",
      label: INDBERETTET_LABEL,
    };
  }

  // erNuvaerendePeriode kommer fra backend'en og har forrang, så de to tilstande ikke kan
  // være uenige om, hvilken dag det er, hen over midnat.
  if (
    !period.erNuvaerendePeriode &&
    isUpcomingPeriod(period.periodeFraDato, now)
  ) {
    return {
      className: "cle-status-badge--info__soft",
      label: KOMMENDE_PERIODE_LABEL,
    };
  }

  if (period.erNuvaerendePeriode && !period.frist) {
    return {
      className: "cle-status-badge--info__soft",
      label: NUVAERENDE_PERIODE_LABEL,
    };
  }

  // Periods with a frist, and ended periods where the indberetning
  // hasn't been created yet, both await reporting.
  return {
    className: "cle-status-badge--warning",
    label: AFVENTER_INDBERETNING_LABEL,
  };
};
